import { i18n, type MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import type { AssetInstanceFillStatus } from 'features/fim'
import type { FacilityModelSearchParams } from 'routes/facility-model/-searchParams'

/** All eight fill states; services deploy independently, so unknown statuses
 * pass through as their raw value rather than crashing the catalog. */
export const FILL_STATUS_LABELS: Record<
  AssetInstanceFillStatus,
  MessageDescriptor
> = {
  missing_type: msg`Missing type`,
  no_template: msg`No template`,
  queued: msg`Queued`,
  running: msg`Running`,
  needs_review: msg`Needs review`,
  complete: msg`Complete`,
  failed: msg`Failed`,
  stale: msg`Stale`,
}

export const fillStatusLabel = (status: string): string => {
  const label = (FILL_STATUS_LABELS as Record<string, MessageDescriptor>)[
    status
  ]
  return label ? i18n._(label) : status
}

/**
 * The filterable subset of the Facility Model search params — derived from the
 * route schema so the URL contract and the filter logic can't drift apart.
 */
export type FacilityModelFilters = Pick<
  FacilityModelSearchParams,
  | 'q'
  | 'terms'
  | 'kind'
  | 'type'
  | 'subsystem'
  | 'promoted'
  | 'fillStatus'
  | 'template'
  | 'validation'
  | 'minSources'
  | 'minConfidence'
>
